import { IMockHandler } from '@/mock/mock.handler.interface';
import { okDeleted, okSingle } from '@/mock/mock.response.util';
import { APPLICATION_SETTING_FIXTURES } from '@/mock/application-setting/application-setting.fixtures';

const ID_ROUTE = /\/email-template\/([^/?]+)$/;

export const emailTemplateHandler: IMockHandler = {
    matches(req: any) {
        if (req.url.includes('/assets/i18n/') || req.url.includes('assets/i18n/')) {
            return false;
        }

        const matches = req.url.includes('/email-template');

        console.log('[EmailTemplateHandler.matches] Returning:', matches);
        return matches;
    },

    handle(req: any) {
        const { method, url } = req;
        const idMatch = url.match(ID_ROUTE);

        // ── GET /application-setting/:id ────────────────────────────────────────
        if (method === 'GET' && idMatch) {
            const found = APPLICATION_SETTING_FIXTURES;
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET /application-setting ────────────────────────────────────────────
        if (method === 'GET' && url.endsWith('/email-template')) {
            return okSingle(APPLICATION_SETTING_FIXTURES);
        }

        // ── POST /application-setting ───────────────────────────────────────────
        if (method === 'POST' && url.endsWith('/email-template')) return okSingle({ ...req.body, id: Date.now() });

        // ── PUT /application-setting/:id ────────────────────────────────────────
        if (method === 'PUT' && idMatch) {
            return okSingle({ ...APPLICATION_SETTING_FIXTURES, ...req.body });
        }

        // ── DELETE /application-setting/:id ─────────────────────────────────────
        if (method === 'DELETE' && idMatch) return okDeleted();

        throw new Error(`[EmailTemplateHandler] unhandled: ${method} ${url}`);
    }
};
